// Explaining the "levels"
// 0 = EASY. Easy to understand, comprehend, etc. Stories without complicated lessons fall here.
// 2 = ADVANCED. Either concept itself is hard, or if not, it takes awhile to land the point.

export const toc = [
    {
        index: 0,
        title: "The Death of Christ",
        author: "John R.W. Stott",
        words: 5893,
        level: 1,
        featured: false,
        updated: false,
        pdf: "https://www.dropbox.com/scl/fi/itdmbt7yaeh96cxkdu11l/01-Death-of-Christ-2020.pdf?rlkey=s1ybu6im1h9zowt5kzr7fuk4k&st=s3yq5st1&dl=0",
        web: "",
        year: 1958, // most recent is 1981 though
        copyright: 2
        // copyright: 0 = no | 1 = possibly | 2 = high possibility | 3 = YES
    },
    {
        index: 1,
        title: "Who Put Jesus on the Cross",
        author: "A.W. Tozer",
        words: 2883,
        level: 1,
        featured: false,
        updated: false,
        pdf: "https://www.dropbox.com/scl/fi/sbwfm9t4jpurc3dubgi6u/02-Who-Put-Jesus-on-the-Cross-2020.pdf?rlkey=jo40muge1imobg0rao4425230&st=0yud4tts&dl=0",
        web: "",
        copyright: 2 // AW Tozer passed away in 1963
    },
    {
        index: 2,
        title: "Protesting Our Innocence",
        author: "Roy Hession",
        words: 2062,
        level: 0,
        featured: false,
        updated: false,
        pdf: "https://www.dropbox.com/scl/fi/3puy85c0273dkqnye4od8/03-Protesting-Our-Innocence-2020.pdf?rlkey=dwvpjr6qdver5w05lcql9azog&st=hauoc92z&dl=0",
        web: "",
        copyright: 2 // Calvary Road first published in 1950; latest 2016
    },
    {
        index: 3,
        title: "Holy Justice",
        author: "R.C. Sproul",
        words: 10865,
        level: 2,
        featured: false,
        updated: false,
        pdf: "https://www.dropbox.com/scl/fi/391swvx89rokbaqb1zu1q/04-Holy-Justice-2020.pdf?rlkey=22qify27abhrxvdtx64slxqav&st=lt1s2pu7&dl=0",
        web: ""
    },
    {
        index: 4,
        title: "Christ's Plea for Ignorant Sinners",
        author: "Charles Spurgeon",
        words: 2606,
        level: 1,
        featured: false,
        updated: false,
        pdf: "https://www.dropbox.com/scl/fi/ha1i3w2hmzse3gvrx6y5n/05-Christ-s-Plea-2020.pdf?rlkey=reaiznaeknc23kc0y5oh4qac0&st=8ap7jq8w&dl=0",
        web: ""
    },
    {
        index: 5,
        title: "Why Did Christ Die?",
        author: "John R.W. Stott",
        words: 6348,
        level: 1,
        featured: false,
        updated: false,
        pdf: "https://www.dropbox.com/scl/fi/zus4ury6ejlakxadsuyqo/06-Why-did-Christ-Die-2020.pdf?rlkey=i6bna60ujvh93uk77xtxredx2&st=ykdhk7iv&dl=0",
        web: ""
    },
    {
        index: 6,
        title: "Remember Me",
        author: "Charles Colson",
        words: 4497,
        level: 0,
        featured: false,
        updated: false,
        pdf: "https://www.dropbox.com/scl/fi/cbfxjjojv1vyhd5s732fc/07-Remember-Me-2020.pdf?rlkey=p0abg3rcjc1bunxlx0f0m0zmp&st=09yagyxv&dl=0",
        web: ""
    },
    {
        index: 7,
        title: "The Power of the Blood of the Lamb",
        author: "Roy Hession",
        words: 1666,
        level: 1,
        featured: false,
        updated: false,
        pdf: "https://www.dropbox.com/scl/fi/fq66vc1e11s046hz8fe0g/08-Power-of-the-Blood-2020.pdf?rlkey=kv13n71qfboumbk2odn4iwm5r&st=xfbqomsl&dl=0",
        web: ""
    },
    {
        index: 8,
        title: "Followers, Not Admirers",
        author: "Søren Kierkegaard",
        words: 1289,
        level: 1,
        featured: true,
        updated: true,
        thumbnail: "09-cover.svg",
        pdf: "https://www.dropbox.com/scl/fi/0w6iocd772tjwsr21gd6q/09-Followers-Not-Admirers-Light-2022.pdf?rlkey=1glqpb5jny29h1gus4r9anu2p&st=ndpg5be2&dl=0",
        pdf_dark: "https://www.dropbox.com/scl/fi/ode3w86zh24vl9sukudgg/09-Followers-not-Admirers-Dark-2022.pdf?rlkey=n69bwpuahxdx5vw9jxtl2hobo&st=e6pcfoae&dl=0",
        web: "followers-not-admirers"
    },
    {
        index: 9,
        title: "Discipleship and the Cross",
        author: "Dietrich Bonhoeffer",
        words: 1277,
        level: 2,
        featured: false,
        updated: true,
        thumbnail: "10-cover.svg",
        pdf: "https://www.dropbox.com/scl/fi/jf3s74lm9z48lun5dx74i/10-Discipleship-and-Cross-Light-2022.pdf?rlkey=5e6olefkziqeacttx73qee4kg&st=rh342302&dl=0",
        pdf_dark: "https://www.dropbox.com/scl/fi/aso5jsd8dh1gwb9rkkjxg/10-Discipleship-and-Cross-Dark-2022.pdf?rlkey=llbvgtud3flaksmevcifoz973&st=ygbi4f1r&dl=0",
        web: "discipleship-and-cross"
    },
    {
        index: 10,
        title: "The Power of Forgiveness",
        author: "Johann C. Arnold",
        words: 1121,
        level: 0,
        featured: false,
        updated: true,
        thumbnail: "11-cover.png",
        pdf: "https://www.dropbox.com/scl/fi/frlict3h2gafl26pq2y2e/11-Power-of-Forgiveness-Light-2022.pdf?rlkey=9uoehq1qz9pywxc64tx9ikful&st=i9oi3vit&dl=0",
        pdf_dark: "https://www.dropbox.com/scl/fi/fc54mll6o0nf7015zuxpe/11-Power-of-Forgiveness-Dark-2022.pdf?rlkey=ik04eskyhrs0jh7ylv9uimfz4&st=n03k3f1j&dl=0",
        web: "power-of-forgiveness"
    },
    {
        index: 11,
        title: "I, Like the Thief",
        author: "Leo Tolstoy",
        words: 365,
        level: 1,
        featured: true,
        updated: true,
        thumbnail: "12-cover.svg",
        pdf: "https://www.dropbox.com/scl/fi/brxjebo66wfqz27smqbiz/12-I-Like-the-Thief-Light-2022.pdf?rlkey=nbhksxfwcekwi87vvekgwrjdl&st=c2587o68&dl=0",
        pdf_dark: "https://www.dropbox.com/scl/fi/ngszfzy7oazgzylhxl0yr/12-I-Like-the-Thief-Dark-2022.pdf?rlkey=emu3x30jfy3kf0j263g6g7qzc&st=uobjcofl&dl=0",
        web: "i-like-thief"
    },
    {
        index: 12,
        title: "The End is Life",
        author: "Frederick Buechner",
        words: 1481,
        level: 1,
        featured: false,
        updated: false,
        pdf: "https://www.dropbox.com/scl/fi/qlcn7yf5xsvko0n7vvgo6/13-End-is-Life-2020.pdf?rlkey=3ty37cszuuzta7nbtq6vzbn13&st=j8xmbdtj&dl=0",
        web: ""
    },
    {
        index: 13,
        title: "The Strangest Story of All",
        author: "C.S. Lewis",
        words: 576,
        level: 1,
        featured: false,
        updated: false,
        pdf: "https://www.dropbox.com/scl/fi/pufbbj7vmz1wzzcxjldya/14-Strangest-Story-of-All-2020.pdf?rlkey=anhslw7ee9kkn4knu9jv3pt13&st=igxxu8pm&dl=0",
        web: ""
    },
    {
        index: 14,
        title: "Threatened by Resurrection",
        author: "Karl Barth",
        words: 1019,
        level: 1,
        featured: false,
        updated: false,
        pdf: "https://www.dropbox.com/scl/fi/phul2w3tqvb79z6m3s1ur/15-Threatened-by-Resurrection-2020.pdf?rlkey=vjwovu6g62z2wx49nlnbv5cmq&st=z6h50uwl&dl=0",
        web: ""
    },
    {
        index: 15,
        title: "The Grand Miracle",
        author: "C.S. Lewis",
        words: 3328,
        level: 2,
        featured: false,
        updated: false,
        pdf: "https://www.dropbox.com/scl/fi/3g1brgpeca49j0l3blsrc/16-Grand-Miracle-2020.pdf?rlkey=2cw4fub2ahj8kfkn48daiztkl&st=ka43cx0f&dl=0",
        web: ""
    }
];
